module.exports = __webpack_public_path__ + "images/test-og-background.webp";